let appWrapper = document.querySelector('#app'),
    scrollElement = document.scrollingElement || document.documentElement,
    scrollFromTop = scrollElement.scrollTop,
    navbar = document.querySelector('.navbar'),
    mainNav = document.querySelector('.main-menu'),
    mainNavTrigger = document.querySelector('.main-menu-trigger'),
    mainNavInTransition = false,
    scrollClass = 'is-scrolling',
    activeClass = 'is-active',
    quantityControlIncrement = document.querySelector('.quantity-control.increment'),
    quantityControlDecrement = document.querySelector('.quantity-control.decrement'),
    quantityControlCart = document.querySelectorAll('.quantity.cart'),
    searchTrigger = document.getElementById('search'),
    closeSearch = document.querySelector('#search-modal .close-modal'),
    cartTrigger = document.getElementById('cart'),
    cartClose = document.getElementById('cart-close'),
    cartModal = document.getElementById('cart-modal');

import ScrollReveal from 'scrollreveal';

if (scrollFromTop > 0) {
    if (navbar) {
        appWrapper.classList.add(scrollClass)

        if (window.matchMedia("(min-width: 1200px)").matches) {
            let opacity = scrollFromTop / 1000

            if (opacity < 1) {
                navbar.style.backgroundColor = 'rgba(255, 255, 255, ' + opacity + ')'
            } else {
                navbar.style.backgroundColor = 'rgba(255, 255, 255, 1)'
            }
        }
    }
}

window.onscroll = function () {
    let el = document.scrollingElement || document.documentElement
    let scrollPosition = el.scrollTop

    if (navbar) {
        if (scrollPosition > 0 && ! appWrapper.classList.contains(scrollClass)) {
            appWrapper.classList.add(scrollClass)
        } else if (scrollPosition == 0 && appWrapper.classList.contains(scrollClass)) {
            appWrapper.classList.remove(scrollClass)
        }

        if (scrollPosition > 0 && window.matchMedia("(min-width: 1200px)").matches) {
            let opacity = scrollPosition / 1000

            if (opacity < 1) {
                navbar.style.backgroundColor = 'rgba(255, 255, 255, ' + opacity + ')'
            } else {
                navbar.style.backgroundColor = 'rgba(255, 255, 255, 1)'
            }
        } else if (! window.matchMedia("(min-width: 1200px)").matches) {
            navbar.style.backgroundColor = '#161615'
        }
    }

    if (scrollPosition > 100 && getCookie('newsletter_shown') != 1) {
        $('#newsletter-modal').modal('show')
        setCookie('newsletter_shown', 1, 90)
    }
}

function setCookie(name, value, durationDays) {
    var d = new Date();
    d.setTime(d.getTime() + durationDays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function getCookie(cookie) {
    var name = cookie + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function handleNavTransitionEvent(e) {
    mainNavInTransition = false
}

if (mainNavTrigger) {
    mainNavTrigger.onclick = function () {
        if (mainNavInTransition === false) {
            mainNavInTransition = true

            if (! mainNav.classList.contains(activeClass)) {
                mainNav.classList.add(activeClass)
                navbar.classList.add(activeClass)
                mainNavTrigger.classList.add(activeClass)
                document.querySelector('body').style.overflow = "hidden"

                mainNav.addEventListener('transitionend', handleNavTransitionEvent, false)
            } else {
                mainNav.classList.remove(activeClass)
                navbar.classList.remove(activeClass)
                mainNavTrigger.classList.remove(activeClass)
                document.querySelector('body').style.overflow = null

                mainNav.addEventListener('transitionend', handleNavTransitionEvent, false)
            }
        }
    }
}

if ($('.card').length > 0) {
    $(".card").on("hidden.bs.collapse", function() {
        $(this).removeClass("active");
    });

    $(".card").on("shown.bs.collapse", function() {
        $(this).addClass("active");
    });
}

if (quantityControlIncrement && quantityControlDecrement) {
    let quantityOfProduct = document.querySelector('input[name="quantity"]')

    quantityControlIncrement.onclick = function () {
        incrementValue(quantityOfProduct)
    }

    quantityControlDecrement.onclick = function () {
        decrementValue(quantityOfProduct)
    }
}

if (quantityControlCart) {
    quantityControlCart.forEach(function (item) {
        let cartId = item.dataset.cartId
        let quantityOfProduct = item.querySelector('input[name="quantity[' + cartId + ']"]')

        let incrementControl = item.querySelector('.increment')
        let decrementControl = item.querySelector('.decrement')

        incrementControl.onclick = function () {
            incrementValue(quantityOfProduct)
        }

        decrementControl.onclick = function () {
            decrementValue(quantityOfProduct)
        }
    })
}

window.reassignControls = function () {
    let cart = document.querySelectorAll('.quantity.cart._modal');

    if (cart) {
        cart.forEach(function (item) {
            let cartId = item.dataset.cartId
            let quantityOfProduct = item.querySelector('input[name="quantity[' + cartId + ']"]')
            let incrementControl = item.querySelector('.increment')
            let decrementControl = item.querySelector('.decrement')

            incrementControl.onclick = function () {
                incrementValue(quantityOfProduct)
            }

            decrementControl.onclick = function () {
                decrementValue(quantityOfProduct)
            }
        })
    }
}

if (cartTrigger && cartClose) {
    let isOpen = '_open';

    cartTrigger.onclick = function () {
        if (!cartModal.classList.contains(isOpen)) {
            cartModal.classList.add(isOpen);
            cartTrigger.classList.add(isOpen);
        }
    }

    cartClose.onclick = function () {
        if (cartModal.classList.contains(isOpen)) {
            cartModal.classList.remove(isOpen);
            cartTrigger.classList.remove(isOpen);
        }
    }
}

if (searchTrigger) {
    let searchModal = document.getElementById('search-modal')
    let searchInput = $('#search-modal .search-input')

    searchTrigger.onclick = function () {
        if (!searchModal.classList.contains(activeClass)) {
            document.querySelector('body').style.overflow = "hidden"
            searchModal.classList.add(activeClass)
            searchInput.focus()
        } else {
            return
        }
    }

    closeSearch.onclick = function () {
        if (searchModal.classList.contains(activeClass)) {
            searchModal.classList.remove(activeClass)
            document.querySelector('body').style.overflow = null
        } else {
            return
        }
    }

    let minLength = 3
    let elResults = $('.search-results')

    searchInput.on('change keyup', function () {
        var _el = $(this),
            _term = _el.val(),
            _chars = _term.length;

        if (_chars >= minLength) {
            $.get('/index.php?route=product/search/suggestSearch', {
                term: _term
            }, function (data) {
                elResults.html('');

                if (! $.isEmptyObject(data)) {
                    $.each(data, function (key, item) {
                        if (! $.isEmptyObject(item)) {
                            elResults.append(
                                `<a href="` + item['href'] + `" class="result">` +
                                    `<figure style="background-image:url('` + item['thumb'] + `')"></figure>` +
                                    `<h3 class="result-title">` + item['name'] + `</h3>` +
                                `</a>`
                            );
                        }
                    });
                }
            });
        } else {
            elResults.html('');
        }
    });
}

ScrollReveal().reveal('.reveal-bottom', {
        origin: 'bottom',
        distance: '50px',
        delay: 200,
        duration: 500,
        easing: 'ease-in',
    })

ScrollReveal().reveal('.reveal-bottom-s1', {
        origin: 'bottom',
        distance: '30px',
        delay: 200,
        duration: 500,
        easing: 'ease-in',
    })

ScrollReveal().reveal('.reveal-bottom-d1', {
        origin: 'bottom',
        distance: '50px',
        delay: 225,
        duration: 500,
        easing: 'ease-in',
    })

ScrollReveal().reveal('.reveal-bottom-d2', {
        origin: 'bottom',
        distance: '50px',
        delay: 250,
        duration: 500,
        easing: 'ease-in',
    })

ScrollReveal().reveal('.reveal-bottom-dd', {
        origin: 'bottom',
        distance: '50px',
        delay: 275,
        duration: 500,
        easing: 'ease-in',
    })

function decrementValue(valueField) {
    let currentValue = parseInt(valueField.value)

    if (currentValue <= 1) {
        currentValue = 1
        return
    }

    valueField.value = currentValue - 1
}

function incrementValue(valueField) {
    let currentValue = parseInt(valueField.value)

    if (currentValue < 1) {
        currentValue = 0
    }

    valueField.value = currentValue + 1
    return
}

window.updateCart = function (cartId) {
    let quantity = document.querySelector('._product-actions input[name="quantity[' + cartId + ']"]')

    if (quantity) {
        cart.update(cartId, quantity.value)
    }
}

reassignControls();

$(function () {
    $('[data-toggle="popover"]').popover()
})
